import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const TocAccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div>
      <a href="#" 
        onClick={toggleAccordion} 
        className="accordion-button nav-link sidebar-toc-category-title collapsed text-wrap text-white">
        {title} <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
      </a>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  )
}

export default TocAccordionItem
